import apiClient from '../client';
import type { Notification, PaginatedResponse } from '../../types';

const notificationService = {
  getAll: async (page = 0, size = 20) => {
    const res = await apiClient.get<PaginatedResponse<Notification>>(
      `/notifications?page=${page}&size=${size}`
    );
    return res.data;
  },

  getUnread: async () => {
    const res = await apiClient.get<Notification[]>('/notifications/unread');
    return res.data;
  },

  getUnreadCount: async () => {
    const res = await apiClient.get<number>('/notifications/unread/count');
    return res.data;
  },

  markAsRead: async (id: string) => {
    await apiClient.put(`/notifications/${id}/read`);
  },

  markAllAsRead: async () => {
    await apiClient.put('/notifications/read-all');
  },

  deleteNotification: async (id: string) => {
    await apiClient.delete(`/notifications/${id}`);
  },
};

export default notificationService;
